/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Marker_Add_WaypointInputs */

const en_ui_studio_marker_add_waypoint = /** @type {(inputs: Ui_Studio_Marker_Add_WaypointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add waypoint`)
};

const de_ui_studio_marker_add_waypoint = /** @type {(inputs: Ui_Studio_Marker_Add_WaypointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wegpunkt hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add waypoint" |
*
* @param {Ui_Studio_Marker_Add_WaypointInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_marker_add_waypoint = /** @type {((inputs?: Ui_Studio_Marker_Add_WaypointInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Marker_Add_WaypointInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_marker_add_waypoint(inputs)
	return de_ui_studio_marker_add_waypoint(inputs)
});